import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import RmeTempHumComponentsStep2Part1 from "./rme-temp-hum-components-step2-parts/rme-temp-hum-components-step2-part1";

export default class RmeTempHumComponentsStep2Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: RmeTempHumComponentsStep2ComponentMainConfig) {
		let context = this;
		context._parts.push(new RmeTempHumComponentsStep2Part1(context.config.scenario, () => {
			context.config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface RmeTempHumComponentsStep2ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: RmeTempHumComponentsStep2ComponentPart1Config;
	onDone: () => void;
}

export interface RmeTempHumComponentsStep2ComponentPart1Config extends GeneralPartConfig {
}